<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Tab, Tabs, Text } from '@Shelly/shelly-design-system';
	import type { ViewVariant } from 'src/types/DeviceUI';

	const dispatch = createEventDispatcher<{ toggler: { variant: ViewVariant; title: string } }>();

	const tabs: { variant: ViewVariant; title: string; description: string }[] = [
		{
			variant: 'basic',
			title: $format('tab_basic_view', { default: 'Basic view' }),
			description: $format('text_title_basic_view', {
				default: 'Basic – clean and minimal layout with essential controls',
			}),
		},
		{
			variant: 'advanced',
			title: $format('tab_advanced_view', { default: 'Advanced view' }),
			description: $format('text_title_advanced_view', {
				default: 'Advanced – shows detailed statistics and measurements',
			}),
		},
	];

	let selectedIndex: number | null = null;

	const selectVariant = (index: number) => {
		selectedIndex = index;
		const tab = tabs[index];
		dispatch('toggler', { variant: tab.variant, title: tab.title });
	};
</script>

<Text styleType="body-small" class="mb-m">
	{$format('text_change_view', {
		default:
			'You can switch between different device views to change the appearance and layout of the default device tab.',
	})}
</Text>

<Tabs class="mb-m">
	{#each tabs as tab, i}
		<Tab active={i === selectedIndex} on:click={() => selectVariant(i)}>
			{tab.title}
		</Tab>
	{/each}
</Tabs>

{#if selectedIndex !== null}
	<Text element="p" styleType="body" class="mt-s">
		{tabs[selectedIndex].description}
	</Text>
{/if}
